import { RootStore } from './root.store';
import { DialogStore, error } from '@fulcrumgt/mobx-store-utils';
import { action, override } from 'mobx';

export default abstract class DialogRootStore<I, O> extends DialogStore<I, O> {
    rootStore: RootStore;
    isKeyboardEvent: boolean = true;

    constructor(rootStore: RootStore) {
        super();
        this.rootStore = rootStore;
    }

    @error() @action.bound handleError(err: {message: string}) {
        this.rootStore.onError(err.message);
    }

    @override
    async resolveAndClose(result: O): Promise<void> {
        super.resolveAndClose(result);
        this.handleFocusOnClose();
    }

    @override
    cancel(): void {
        super.cancel();
        this.handleFocusOnClose();
    }

    handleFocusOnClose() {
        const { previousActiveElements, setDialogEscClose } = this.rootStore.appStore;
        const index = previousActiveElements.length - 1;
        setDialogEscClose(true);
        if (index >= 0) {
            const activeElement = previousActiveElements[index];
            previousActiveElements.pop();
            requestAnimationFrame(() => {
                if (this.isKeyboardEvent) {
                    activeElement.focus();
                }
                this.isKeyboardEvent = true;
                setDialogEscClose(false);
            });
        } else {
            setDialogEscClose(false);
        }
    }

    handleEventType = (e: React.MouseEvent) => {
        this.isKeyboardEvent = !((e.nativeEvent as PointerEvent).pointerType);
    }
}
